import {
  createSlice,
  createEntityAdapter,
  PayloadAction,
  EntityState,
} from '@reduxjs/toolkit';
import { PublisherMedia } from 'core/models';
import { ProcessStatus } from 'states';

export const entityAdapter = createEntityAdapter<PublisherMedia>({
  selectId: (model) => model.id,
  sortComparer: (a, b) => a.id.localeCompare(b.id),
});

interface PublisherMediaState extends EntityState<PublisherMedia> {
  status: ProcessStatus;
}

const initialState: PublisherMediaState = entityAdapter.getInitialState({
  status: 'idle',
});

const slice = createSlice({
  name: 'publisherMedia',
  initialState,
  reducers: {
    resetStatus(state) {
      state.status = 'idle';
    },
    list(state) {
      state.status = 'loading';
    },
    listSuccess(state, action: PayloadAction<PublisherMedia[]>) {
      entityAdapter.addMany(state, action.payload);
      state.status = 'success';
    },
    listFailure(state) {
      state.status = 'failure';
    },
  },
});

export const actions = slice.actions;
export default slice;
